module.exports = __webpack_public_path__ + "components/app-promo/static/en/snow-forecast__app-screenshot--1-9f5956874462261caaa9e50e76cb9838.jpg";